export default __webpack_public_path__ + "static/media/mai.fe853705.png";